import Examples from '@/components/examples/Examples';
import React from 'react';

export default function _Examples() {
  return <Examples />;
}
